const objectMap = require('./object-map')
const isPlainObject = require('lodash/isPlainObject')

module.exports = function objectMapDeep (mapValue, mapKey) {
  function mapValueDeep (value) {
    if (isPlainObject(value)) { return objectMapDeep(mapValue, mapKey)(value) }

    if (Array.isArray(value)) { return value.map(objectMapDeep(mapValue, mapKey)) }

    return mapValue(value)
  }

  return objectMap(mapValueDeep, mapKey)
}
